module.exports = __webpack_public_path__ + "static/media/ico_whatsapp.f38f27b0.svg";